import { registerTableEvent } from "./index";
import { toast } from "../../toast";

export function registerCopyEvent(modelLabel: string, columnId: string): void {
  registerTableEvent(modelLabel, "cell_click", (ctx) => {
    if (ctx.column?.id !== columnId) return;

    const cellValue = ctx.row[columnId]?.text;
    if (cellValue) {
      navigator.clipboard.writeText(String(cellValue));
      toast.success(`ID ${cellValue} скопирован`);
    }
  });
}
